import { render } from "./matrices_efe.vue?vue&type=template&id=21455e65&scoped=true"
import script from "./matrices_efe.vue?vue&type=script&lang=js"
export * from "./matrices_efe.vue?vue&type=script&lang=js"

import "./matrices_efe.vue?vue&type=style&index=0&id=21455e65&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21455e65"]])

export default __exports__